module.exports = __webpack_public_path__ + "img/viber image 2019-04-08 , 19.09.27.f7b52623.jpg";